import React, { useEffect, useState } from 'react'
import {Link, useLocation } from "react-router-dom";
import { FaList } from "react-icons/fa6";
import { GiCrossedSabres } from "react-icons/gi";


export default function NavtabBar() {

  const location = useLocation()
  const[scrolled,setScrolled] = useState(false)

  const navItems = [
    {name:"Home", link:"/"},
    // {name:"Projects", link:"/projects"}
  ];

  const handleContactClick = () => {
    document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  },[])

  const[menu, setMenu] = useState(false)
  return (
    <div className="w-full fixed pt-4 top-0 left-0 z-50 flex justify-center items-center">
      <nav className={`w-[90%] min-h-12 bg-white/50 backdrop-blur-md rounded-2xl px-8 flex items-center justify-between shadow-[0_8px_25px_rgba(0,0,0,0.25)] transition-all duration-300 ease-in-out
      ${scrolled? "py-4 md:py-2" : "py-6"}`}>
        {/* Logo */}
        <Link className="flex w-[60%] md:w-[20%] h-full items-center" to={"/"}>
          <img
            src={`${process.env.PUBLIC_URL}/photos/LogoBlack.png`}
            alt="Sudip"
            className={` object-cover transition-all duration-300 ease-in-out ${scrolled? "h-full w-full md:h-[80%] md:w-[80%]":"h-full w-full"}`} 
          />
        </Link>

        {/* Navigation */}
        <ul className="flex w-[90%] h-full items-center justify-center gap-10">
          {navItems.map((item, index) => (
            <Link
              key={item.link}
              to={item.link}
              className={`relative cursor-pointer text-[14px] md:text-[18px] font-medium transition-all duration-100 ease-in-out ${
                item.link === location.pathname ? "text-black font-bold" : "text-black/50"
              }`}
            >
              {item.name}

              {item.link === location.pathname && (
                <>
                  {/* <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-10 rounded-xl bg-white/10 blur-md" /> */}
                  <span className="absolute left-1/2 -translate-x-1/2 top-8 w-6 h-[2px] rounded-full bg-[#000]" />
                </>
              )}
            </Link>
          ))}
        </ul>
        <button className={`bg-[#ffd119] backdrop-blur-md px-4 rounded-lg text-[12px] md:text-base hover:bg-[#ffd119]/70 hover:scale-[1.03] active:scale-[1] transition-all duration-300 ease-in-out ${scrolled? "py-1" : "py-2"}`}
        onClick={handleContactClick}>Contact</button>
      </nav>
    </div>
  );
}
